export default __webpack_public_path__ + "static/media/noDataImae.9eab6e8f.png";